"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var License_exports = {};
__export(License_exports, {
  default: () => License_default
});
module.exports = __toCommonJS(License_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.77778 4.07812C4.45226 4.07812 4.17231 4.19531 3.93793 4.42969C3.71658 4.65104 3.6059 4.92448 3.6059 5.25V11.9102C3.6059 12.2357 3.71658 12.5156 3.93793 12.75C4.17231 12.9714 4.45226 13.082 4.77778 13.082H14.7778C15.1033 13.082 15.3767 12.9714 15.5981 12.75C15.8325 12.5156 15.9497 12.2357 15.9497 11.9102V5.25C15.9497 4.92448 15.8325 4.65104 15.5981 4.42969C15.3767 4.19531 15.1033 4.07812 14.7778 4.07812H4.77778ZM2.60981 5.25C2.60981 4.65104 2.81814 4.14323 3.23481 3.72656C3.6645 3.29688 4.17882 3.08203 4.77778 3.08203H14.7778C15.3767 3.08203 15.8845 3.29688 16.3012 3.72656C16.7309 4.14323 16.9457 4.65104 16.9457 5.25V11.9102C16.9457 12.5091 16.7309 13.0234 16.3012 13.4531C15.8845 13.8698 15.3767 14.0781 14.7778 14.0781H4.77778C4.17882 14.0781 3.6645 13.8698 3.23481 13.4531C2.81814 13.0234 2.60981 12.5091 2.60981 11.9102V5.25ZM3.2934 13.9609C3.42361 14 3.51476 14.0846 3.56684 14.2148C3.61892 14.3451 3.61892 14.4753 3.56684 14.6055L3.19575 15.543C3.15668 15.6471 3.1697 15.7513 3.23481 15.8555C3.29991 15.9466 3.39106 15.9922 3.50825 15.9922H16.0473C16.1645 15.9922 16.2556 15.9466 16.3207 15.8555C16.3859 15.7513 16.3989 15.6471 16.3598 15.543L15.9887 14.6055C15.9366 14.4753 15.9366 14.3451 15.9887 14.2148C16.0408 14.0846 16.1319 14 16.2622 13.9609C16.3924 13.9089 16.5161 13.9089 16.6332 13.9609C16.7635 14.013 16.8546 14.1042 16.9067 14.2344L17.2778 15.1719C17.4601 15.6146 17.4145 16.0312 17.1411 16.4219C16.8806 16.8125 16.5161 17.0078 16.0473 17.0078H3.50825C3.0395 17.0078 2.6684 16.8125 2.39497 16.4219C2.13455 16.0312 2.09549 15.6146 2.27778 15.1719L2.64887 14.2344C2.70095 14.1042 2.78559 14.013 2.90278 13.9609C3.03299 13.9089 3.16319 13.9089 3.2934 13.9609ZM7.68793 15.25C7.68793 15.1328 7.727 15.0352 7.80512 14.957C7.89627 14.8789 8.00043 14.8398 8.11762 14.8398H11.4379C11.5551 14.8398 11.6528 14.8789 11.7309 14.957C11.822 15.0352 11.8676 15.1328 11.8676 15.25C11.8676 15.3672 11.822 15.4648 11.7309 15.543C11.6528 15.6211 11.5551 15.6602 11.4379 15.6602H8.11762C8.00043 15.6602 7.89627 15.6211 7.80512 15.543C7.727 15.4648 7.68793 15.3672 7.68793 15.25Z",
      fill: "currentColor"
    }
  )
);
const SvgLicense = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var License_default = SvgLicense;
